import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { FeatureToggleValue, FeatureToggleValueSchema } from './feature-toggle.value.entity';
import { SiftQuerySchema } from './feature-toggle.expression';

export const FeatureToggleConditionSchema = z
    .object({
        expression: SiftQuerySchema,
        value: FeatureToggleValueSchema,
    })
    .strict();

export class FeatureToggleCondition extends FromSchema(FeatureToggleConditionSchema) {
    expression: object;
    value: FeatureToggleValue;
}
